module.exports = __webpack_public_path__ + "assets/img/7.a5e55e1f.png";